<div class="modal-header">
  <div class="d-flex align-items-center gap-3">
    <span class="my-access__avatar rounded-circle d-flex align-items-center justify-content-center fw-bold text-white">{{ userNameInitials }}</span>
    <div>
      <div class="modal-chrome-eyebrow">{{ userEmailName }}</div>
      <h2 class="modal-chrome-title">My access &amp; scopes</h2>
      @if (details(); as d) {
        <div class="my-access__summary text-muted">ID {{ d.id }} · {{ roleCount() }} roles · {{ scopeCount() }} scopes</div>
      }
    </div>
  </div>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  @if (loading()) {
    <div class="my-access__loading text-muted">Loading your access…</div>
  } @else if (error()) {
    <app-empty-state icon="bi-exclamation-circle" title="Couldn't load your access" message="Something went wrong loading your access details.">
      <button type="button" class="btn btn-modal-submit rounded-pill" (click)="load()">Retry</button>
    </app-empty-state>
  } @else {
    <div class="my-access__cards">
      <app-section-card heading="Roles">
        @if (roles().length) {
          <div class="my-access__roles d-flex flex-wrap gap-2">
            @for (role of roles(); track role) {
              <app-chip [label]="role" variant="navy" size="md" />
            }
          </div>
        } @else {
          <app-empty-state icon="bi-person-badge" title="No roles assigned" message="You don't have any roles assigned yet." />
        }
      </app-section-card>

      <app-section-card heading="Permission Scopes" [headingSuffix]="'· ' + scopeCount()">
        <button type="button" card-actions class="btn btn-link btn-sm p-0 my-access__toggle" (click)="toggleScopes()">{{ expanded() ? 'Hide' : 'Show' }}</button>
        @if (scopeCount()) {
          <p class="my-access__scopes-help">Fine-grained API scopes assigned alongside roles, per the auth contract. Hidden from common support users — roles above are the everyday surface.</p>
          @if (expanded()) {
            <div class="my-access__scope-groups">
              @for (group of scopeGroups(); track group.domain) {
                <div class="my-access__scope-group">
                  <div class="my-access__scope-group-header">
                    <span class="my-access__scope-group-label">
                      @for (part of (group.domain | uppercase).split('/'); track $index) {
                        @if ($index > 0) {
                          <span class="my-access__scope-group-separator">/</span>
                        }
                        {{ part }}
                      }
                    </span>
                    <span class="my-access__scope-group-count">{{ group.count }}</span>
                    <hr class="my-access__scope-group-divider" />
                  </div>
                  <ul class="my-access__scope-list list-unstyled m-0">
                    @for (item of group.items; track item.raw) {
                      <li class="my-access__scope-row">
                        <span class="my-access__scope-verb my-access__scope-verb--{{ scopeVerbModifier(item.verb) }}">{{ (item.verb || '—').toUpperCase() }}</span>
                        <code class="my-access__scope-name">{{ item.raw }}</code>
                      </li>
                    }
                  </ul>
                </div>
              }
            </div>
          }
        } @else {
          <app-empty-state icon="bi-shield-lock" title="No scopes" message="You don't have any API scopes assigned." />
        }
      </app-section-card>
    </div>
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary-hollow rounded-pill" (click)="close()">Close</button>
</div>
